import { FC, Fragment, useState, useCallback } from 'react'
import { Row, Col, Text, HorizontalScroll, Icon, Tag, Content } from '@/client/components'
import { useWindowSize } from '@/client/hooks'
import * as S from './styles'
import { ListProps } from '../types'

export const List: FC<ListProps> = ({ search_input_label, glossary }) => {
  const windowSize = useWindowSize()
  const isLgBreakpoint = windowSize?.width > 768
  const [selected, setSelected] = useState<string>('')
  const [searchValue, setSearchValue] = useState<string>('')

  const handleChangeSearchValue = useCallback((event) => {
    const { value } = event.currentTarget
    setSearchValue(value)
  }, [])

  const filter = glossary?.map(({ letter }) => (
    <Tag
      key={letter}
      size='large'
      kind='filter'
      action={() =>
        setSelected((currState) => {
          setSearchValue('')
          if (currState === letter) return ''
          return letter
        })
      }
      isActive={letter === selected}
    >
      {letter.toUpperCase()}
    </Tag>
  ))

  const filteredGlossary = searchValue
    ? glossary.filter(
        ({ title, explanation }) =>
          title.toLowerCase().includes(searchValue.toLowerCase()) ||
          explanation.toLowerCase().includes(searchValue.toLowerCase())
      )
    : glossary.filter(({ letter }) => letter.includes(selected))

  const highlightSearchValue = (text, searchValue) => {
    if (!searchValue) return text

    const regex = new RegExp(`(${searchValue})`, 'gi')
    return text.replace(regex, `<mark>$1</mark>`)
  }

  return (
    <>
      <Row>
        <Col xs={12}>
          <S.Filter>
            {!isLgBreakpoint && <HorizontalScroll>{filter}</HorizontalScroll>}
            {isLgBreakpoint && <>{filter}</>}
          </S.Filter>

          <S.Search
            isBlock
            id='input-search'
            type='search'
            placeholder={search_input_label}
            value={searchValue}
            onChange={handleChangeSearchValue}
            autoComplete='off'
            rightElement={
              <S.SearchIcon aria-label='Search'>
                <Icon name='search' size='s5' />
              </S.SearchIcon>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {filteredGlossary.map(({ title, explanation }) => (
            <Fragment key={title}>
              <Text family='heading' color='primary' size='lg' weight='bold'>
                {title}
              </Text>
              <Content content={highlightSearchValue(explanation, searchValue)} />
            </Fragment>
          ))}
        </Col>
      </Row>
    </>
  )
}
